import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import dp from "../../Images/dp.svg";
import lc from "../../Images/lc.svg";
import pref from "../../Images/pref.svg";
import help from "../../Images/help.svg";
import rate from "../../Images/rate.svg";
import diary from "../../Images/diary.svg";
import school from "../../Images/school.png";
import profile from "../../Images/profile.png";
import password from "../../Images/password.png";
import viewall from "../../Images/viewall.png";
import assignments from "../../Images/assignments.svg";
import r_arrow from "../../Images/r_arrow.svg";
import SchoolCardV2 from "../../Components/Profile/SchoolCardV2";
import ProfileCardV2 from "../../Components/Profile/ProfileCard";
import HeaderV2 from "../../Layout/Header";
import { logout } from "../../../../services/users";
import ProfileSession from "../../Components/Profile/ProfileSession";
import BodyCard from "../../Components/Home/BodyCard";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

const HeadList = [
  {
    route: "/AssignedHomework",
    image: assignments,
    label: "Assignments",
  },
  {
    route: "/homeWork",
    image: diary,
    label: "Diary",
  },
  {
    route: "/liveClass",
    image: lc,
    label: "Live Class",
  },
  {
    route: "/teacherHomeV2",
    image: viewall,
    label: "View All",
  },
];

const BodyList = [
  {
    route: "/gallery",
    image: pref,
    label: "Preferences",
    desc: "Language, Notification",
  },
  {
    route: "/gallery",
    image: help,
    label: "Help & Support",
    desc: "FAQs & Links",
  },
  {
    route: "/gallery",
    image: rate,
    label: "Rate Us",
    desc: "FAQs & Links",
  },
];

function HeadTab(props) {
  return (
    <>
      <Link to={props.route}>
        <div
          className="mx-auto text-center th-br-12"
          style={{
            opacity: "0.9",
          }}
        >
          <img
            src={props.image}
            alt=""
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            }}
            className="p-3 th-br-12 shadow-sm"
          />
        </div>
        <div
          className="my-2 th-fw-600 th-12 text-center"
          style={{ color: "#FFFFFF", opacity: "0.8" }}
        >
          {props.label}
        </div>
      </Link>
    </>
  );
}

function BodyTab(props) {
  return (
    <>
      <Link to={props.route} className="d-block th-bg-white m-4 th-br-16">
        <div
          className="d-flex th-bg-white p-2 th-br-16"
          style={{ border: "2px solid #EAECF0" }}
        >
          <div
            className="mx-2 my-auto th-br-100"
            style={{ background: "#EFF4FF" }}
          >
            <img src={props.image} alt="" className="p-2" />
          </div>
          <div className="p-2 align-items-left">
            <div className="th-fw-600" style={{ color: "#212529" }}>
              {props.label}
            </div>
            <div className="th-14 th-grey">{props.desc}</div>
          </div>
          <div className="ml-auto my-auto px-2">
            <img src={r_arrow} alt="" className="" />
          </div>
        </div>
      </Link>
    </>
  );
}

const TeacherProfileV2 = () => {
  return (
    <>
      <div className="mb-1">
        <HeaderV2 to="/profile" title="Profile" />
        <div
          className="pt-1"
          style={{
            background:
              "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
            paddingBottom: "60px",
          }}
        >
          <ProfileCardV2 />
          <ProfileSession />
          {/* <div className="row px-3 my-2">
              {HeadList?.map((eachHead) => {
                return (
                  <div className="col-3">
                    <HeadTab
                      route={eachHead.route}
                      image={eachHead.image}
                      label={eachHead.label}
                    />
                  </div>
                );
              })}
            </div> */}
        </div>
        <div className="th-br-25 th-bg-white" style={{ marginTop: "-30px" }}>
          {/* <div className="flex-vertical mx-0 py-4">
            <Link to="/aboutSchool">
              <SchoolCardV2 />
            </Link> */}
          {/* {BodyList?.map((eachBody) => {
              return (
                <BodyTab
                  route={eachBody.route}
                  image={eachBody.image}
                  label={eachBody.label}
                  desc={eachBody.desc}
                />
              );
            })} */}

          {/* <Link
              to="/tnotifications"
              className="d-block th-bg-white m-4 th-br-16"
            >
              <div
                className="d-flex th-bg-white p-2 th-br-16"
                style={{ border: "2px solid #EAECF0" }}
              >
                <div
                  className="mx-2 my-auto th-br-100"
                  style={{ background: "#EFF4FF" }}
                >
                  <img src={pref} alt="" className="p-2" />
                </div>
                <div className="p-2 align-items-left">
                  <div className="th-fw-600" style={{ color: "#212529" }}>
                    Preferences
                  </div>
                  <div className="th-14 th-grey">Language, Notification</div>
                </div>
                <div className="ml-auto my-auto px-2">
                  <img src={r_arrow} alt="" className="" />
                </div>
              </div>
            </Link>
            <div className="d-block th-bg-white m-4 th-br-16">
              <div
                className="d-flex th-bg-white p-2 th-br-16"
                style={{ border: "2px solid #EAECF0" }}
              >
                <div
                  className="mx-2 my-auto th-br-100"
                  style={{ background: "#EFF4FF" }}
                >
                  <img src={help} alt="" className="p-2" />
                </div>
                <div className="p-2 align-items-left">
                  <div className="th-fw-600" style={{ color: "#212529" }}>
                    Help & Support
                  </div>
                  <div className="th-14 th-grey">FAQs & Links</div>
                </div>
                <div className="ml-auto my-auto px-2">
                  <img src={r_arrow} alt="" className="" />
                </div>
              </div>
            </div>
            <div className="d-block th-bg-white m-4 th-br-16">
              <div
                className="d-flex th-bg-white p-2 th-br-16"
                style={{ border: "2px solid #EAECF0" }}
              >
                <div
                  className="mx-2 my-auto th-br-100"
                  style={{ background: "#EFF4FF" }}
                >
                  <img src={rate} alt="" className="p-2" />
                </div>
                <div className="p-2 align-items-left">
                  <div className="th-fw-600" style={{ color: "#212529" }}>
                    Rate Us
                  </div>
                  <div className="th-14 th-grey">FAQs & Links</div>
                </div>
                <div className="ml-auto my-auto px-2">
                  <img src={r_arrow} alt="" className="" />
                </div>
              </div>
            </div> */}

          <div className="row px-3 pt-4 mx-0 my-auto">
            <div className="col-4">
              <BodyCard
                route="/aboutSchool"
                image={school}
                label="School Profile"
              />
            </div>
            <div className="col-4">
              <BodyCard
                route="/profileDetails"
                image={profile}
                label="My Profile"
              />
            </div>
            <div className="col-4">
              <BodyCard
                route="/password"
                image={password}
                label="Change Password"
              />
            </div>
          </div>

          <div className="mb-5 pb-4 text-center fixed-bottom">
            <button
              className="th-btn-primary py-2 px-3 th-14"
              onClick={logout}
              style={{
                background:
                  "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
              }}
            >
              Logout
            </button>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps)(TeacherProfileV2);
